app.directive('imageBannerDisplay', [
  'imageService',
  '$window',
  '$filter',
  function (imageService, $window, $filter) {
    return {
      transclude: false,
      restrict: 'E',
      scope: {
        mobileMedia: '=',
        desktopMedia: '=',
      },
      templateUrl:
        '/themes/v1/default/views/templates.image-banner-display.html',
      link: function (scope) {
        var isMobile = $window.innerWidth < 768;

        function switchMediaPlatform() {
          var isMobileValid = scope.mobileMedia;
          scope.media =
            isMobile && isMobileValid ? scope.mobileMedia : scope.desktopMedia;
        }

        switchMediaPlatform();

        scope.getImage = function (media) {
          var imageSize =
            $('image-banner-display .sl-lazy-image')
              .first()
              .attr('data-size') || '600x';
          return imageService.getMediaImageUrl(media, { size: imageSize });
        };

        scope.$on('window.resize', function () {
          if ($window.innerWidth < 768 && !isMobile) {
            isMobile = true;
          } else if ($window.innerWidth >= 768 && isMobile) {
            isMobile = false;
          }
          switchMediaPlatform();
        });

        scope.getAlt = function (media) {
          if (!media) return '';
          return $filter('translateModel')(media.alt_translations);
        };
      },
    };
  },
]);
